import { render, staticRenderFns } from "./goldBusinessManage.vue?vue&type=template&id=caf952fe&scoped=true"
import script from "./goldBusinessManage.vue?vue&type=script&lang=js"
export * from "./goldBusinessManage.vue?vue&type=script&lang=js"
import style0 from "./goldBusinessManage.vue?vue&type=style&index=0&id=caf952fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf952fe",
  null
  
)

export default component.exports